/**
 * Styled Components - Created by david on 09/04/18.
 */
import styled from 'styled-components'
import Upload from 'antd/lib/upload'
import { GRAY, GRAY_DARK, GRAY_LIGHT, RED } from '../../theme/colors'

const { Dragger } = Upload

interface DraggerProps {
  gallery?: boolean
  secondary?: boolean
}

export const Container = styled.div`
  height: 120px;
  width: 222px;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
`

export const Text = styled.div`
  color: #fff;
`

export const DragMessage = styled.div`
  color: ${({ gallery, secondary }: DraggerProps) => gallery ? GRAY_DARK : (secondary ? '#457fc3' : GRAY)};
  padding: ${({ gallery }: DraggerProps) => gallery ? '6px 0px' : '4px 0px'};
  font-size: 16px;
  line-height: 22px;
  @media (max-width: 320px) {
    font-size: 13px;
  }
`

export const DragTypes = styled.div`
  color: ${({ gallery, secondary }: DraggerProps) => gallery ? GRAY_DARK : (secondary ? '#457fc3' : GRAY)};
  font-size: ${({ gallery }: DraggerProps) => gallery ? '18px' : '13px'};
  line-height: 18px;
  margin-top: 12px;
  ${({ gallery }: DraggerProps) => gallery ? `
    color:  #302628;
    text-align: center;
    font-family: "Avenir Next";
    font-weight: 600;
    @media (max-width: 320px) {
      font-size: 15px;
    }
  ` : ''}
`

export const Icon = styled.img`
  margin-bottom: 8px;
  filter: ${({ gallery }: DraggerProps) => gallery ? 'brightness(0.2)' : 'unset'};
`

export const PreviewImage = styled.img`
  width: 100%
  height: 194px;
`

export const StyledDragger = styled(Dragger)`
  user-select: none;
  & .ant-upload {
    width: ${({ gallery }: DraggerProps) => gallery ? '100%' : 'auto'};
  }
  ${({ gallery }: DraggerProps) => gallery ? `
    & .ant-upload.ant-upload-drag {
      border-radius: 12px;
      border: 2px dashed ${GRAY_LIGHT};
      background: #F5F5F5;
    }
  ` : ''}
`

export const GalleryButton = styled.div`
  color: #2196F3;
  font-size: 14px;
  padding: 4px 10px;
  display: inline-flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 6px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
  }
`

export const AcceptedLabel = styled.span`
  color: ${GRAY_DARK};
  font-size: 13px;
  margin-right: 8px;
`

export const AcceptedTagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  gap: 6px;
`

export const AcceptedTag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  color: ${GRAY_DARK};
  background: white;
  border-radius: 3px;
  font-weight: 500;
`

export const buttonStyle = {
  width: '20%',
  margin: '16px 0px'
}

export const draggerStyle = { padding: '30px 0px' }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DraggerWithLoading/styledComponents.tsx